import React from 'react';
import { useTranslation } from 'react-i18next';
import './SubscriptionPlanBadge.less';

interface Props {
  value: string;
}

export default function SubscriptionPlanBadge({ value }: Props) {
  const { t } = useTranslation();

  return (
    <span className="subscription-plan-badge">
      {t(`subscriptions.manage_plans.table.rows.plans.${value}`)}
    </span>
  );
}
